import { Navigate } from "react-router-dom";
import { isAuthenticated, isAdmin, logout } from "./authService";

const AdminProtectedRoute = ({ children }) => {

 // Not logged in
 if (!isAuthenticated()) {
 return <Navigate to="/admin/login" replace />;
 }

 // Logged in but not admin
 if (!isAdmin()) {
 logout();
 return <Navigate to="/admin/login" replace />;
 }

 return children;
};

export default AdminProtectedRoute;
